// extracted by mini-css-extract-plugin
module.exports = {"bucketContainer":"jobBuckets_bucketContainer__YSd2a"};